import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/BootstrapCompo";
import { handleError } from "../../context/Provider";
import henceforthApi from "../../utils/henceforthApi";
import BreadCrumb from "../../components/common/BreadCrumb";

const AdminFees = () => {
    const [feePercent, setFeePercent] = useState<string | number>("");
    const [loading, setLoading] = useState(false);
    const [exists, setExists] = useState(false);
    const [fetching, setFetching] = useState(true);

    const breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        { name: 'Settings', url: `/setting`, active: '' },
        { name: 'Admin Fees', url: ``, active: 'not-allowed' }
    ];

    const fetchFees = async () => {
        setFetching(true);
        try {
            const apiRes = await henceforthApi.commission.getCommission();
            if (apiRes?.data && apiRes.data.fee_percent !== undefined) {
                setFeePercent(apiRes.data.fee_percent);
                setExists(true);
            } else {
                setExists(false);
            }
        } catch (error) {
            setExists(false);
            // handleError(error);
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        fetchFees();
    }, []);

    const handleUpdate = async (e: any) => {
        e.preventDefault();
        if (Number(feePercent) > 100) {
            return toast.error("Fee percentage should not be greater than 100");
        }
        setLoading(true);
        const data = {
            fee_percent: Number(feePercent),
            language: "ENGLISH"
        };
        try {
            let apiRes;
            if (exists) {
                apiRes = await henceforthApi.commission.editCommission(data);
            } else {
                apiRes = await henceforthApi.commission.addCommission(data);
            }
            toast.success(apiRes.message || "Fee updated successfully");
            fetchFees();
        } catch (error: any) {
            if (!exists && error?.status === 400) {
                // Maybe it already exists? try PUT anyway if POST failed with 400
                try {
                    let apiRes = await henceforthApi.commission.editCommission(data);
                    toast.success(apiRes.message || "Fee updated successfully");
                    fetchFees();
                    return;
                } catch (err) {
                    handleError(err);
                }
            }
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />

            <div className='page-spacing'>
                <section className='edit-profile'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-sm-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Admin Fees</h5>
                                    </div>
                                    <div className="common-card-content">
                                        {fetching ? (
                                            <div className="text-center py-4">
                                                <Spinner />
                                            </div>
                                        ) : (
                                            <form onSubmit={handleUpdate}>
                                                <div className='form-fields-box mb-3'>
                                                    <label>Fee Percentage (%):</label>
                                                    <input
                                                        type="text"
                                                        className="form-control rounded-0"
                                                        value={feePercent}
                                                        onChange={(e) => {
                                                            let value = e.target.value.replace(/[^\d.]/g, "");
                                                            if (Number(value) > 100) {
                                                                value = "100";
                                                            }
                                                            setFeePercent(value);
                                                        }}
                                                        placeholder="Enter fee percentage"
                                                        required
                                                    />
                                                </div>
                                                <div className='signin-button-box'>
                                                    <button type='submit' className='btn btn-theme w-100' disabled={loading}>
                                                        {loading ? <Spinner /> : <span><i className='fa fa-save me-2'></i>Update Fees</span>}
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AdminFees;
